import { render } from "./ClientProveedoresNuevo.vue?vue&type=template&id=5e8ad059&scoped=true"
import script from "./ClientProveedoresNuevo.vue?vue&type=script&lang=js"
export * from "./ClientProveedoresNuevo.vue?vue&type=script&lang=js"

import "./ClientProveedoresNuevo.vue?vue&type=style&index=0&id=5e8ad059&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8ad059"]])

export default __exports__